import { useEffect } from 'react';
import CookieManager from "../../Utils/CookieManager";
import { getWidgetsNames } from "../../Helpers/widgets";
import { REPEAT_USER_COOKIE_NAME, SELLER_STATE_COOKIE, EVALUATION_STATES, USER_VISIT_STATUS } from "../../Constants/evaluation";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { UNKNOWN } from "../../Constants/locations";
import { getAcquisitionChannelTrackingValues } from "../../Utils/LayoutHelper";
var useTracker = function useTracker(_ref) {
  var layout = _ref.layout,
    track = _ref.track,
    browsingMode = _ref.browsingMode,
    locationId = _ref.locationId,
    origin = _ref.origin,
    config = _ref.config;
  useEffect(function () {
    var hideOlxAutosWidgetsShown = config && config.get('olxAutos', 'hideOlxAutosWidgetsShown') || false;
    if (!hideOlxAutosWidgetsShown && layout && layout.sections && track && browsingMode) {
      var trackingInfo = Object.assign({
        variants_shown: getWidgetsNames(layout.sections),
        user_type: CookieManager.readCookie(REPEAT_USER_COOKIE_NAME) ? USER_VISIT_STATUS.REPEAT : USER_VISIT_STATUS.FIRST_TIME,
        browsing_location_id: locationId || UNKNOWN,
        reason: CookieManager.readCookie(SELLER_STATE_COOKIE) || EVALUATION_STATES.INITIAL,
        browsing_mode: browsingMode,
        origin: origin
      }, getAcquisitionChannelTrackingValues());
      track(TRACKING_EVENTS.OLXAUTOS_WIDGETS_SHOWN, trackingInfo);
    }
  }, [layout, track, browsingMode, origin, locationId, config]);
  return null;
};
export default useTracker;